import { render, staticRenderFns } from "./post-delete.vue?vue&type=template&id=2fcfc357&scoped=true"
import script from "./post-delete.vue?vue&type=script&lang=js"
export * from "./post-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcfc357",
  null
  
)

export default component.exports